module.exports = __webpack_public_path__ + "img/tel.8a62bef0.svg";